var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSettingIcon = function SvgSettingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#setting-icon_svg__a)",
    stroke: "currentcolor",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 26.25a5.25 5.25 0 1 0 0-10.5 5.25 5.25 0 0 0 0 10.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 22.54v-3.08a3.335 3.335 0 0 1 3.325-3.325c3.167 0 4.462-2.24 2.87-4.988a3.323 3.323 0 0 1 1.225-4.532l3.027-1.732c1.383-.823 3.168-.333 3.99 1.05l.193.332c1.575 2.748 4.165 2.748 5.758 0l.192-.332c.823-1.383 2.608-1.873 3.99-1.05l3.027 1.732a3.323 3.323 0 0 1 1.225 4.533c-1.592 2.747-.297 4.987 2.87 4.987a3.335 3.335 0 0 1 3.325 3.325v3.08a3.335 3.335 0 0 1-3.325 3.325c-3.167 0-4.462 2.24-2.87 4.988a3.32 3.32 0 0 1-1.225 4.532l-3.027 1.733c-1.383.822-3.168.332-3.99-1.05l-.192-.333c-1.576-2.748-4.166-2.748-5.758 0l-.192.333c-.823 1.382-2.608 1.872-3.99 1.05l-3.028-1.733a3.323 3.323 0 0 1-1.225-4.532c1.592-2.748.297-4.988-2.87-4.988A3.335 3.335 0 0 1 3.5 22.54Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "setting-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M0 0h42v42H0z"
  })))));
};

export default SvgSettingIcon;